var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUserCircleCheckDisabled = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 21,
  height: 20,
  viewBox: "0 0 21 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M10.0898 12.5C11.8157 12.5 13.2148 11.1009 13.2148 9.375C13.2148 7.64911 11.8157 6.25 10.0898 6.25C8.36395 6.25 6.96484 7.64911 6.96484 9.375C6.96484 11.1009 8.36395 12.5 10.0898 12.5Z",
  stroke: "#CAC4CF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.07422 15.5747C5.54446 14.6485 6.262 13.8705 7.1473 13.3271C8.0326 12.7837 9.05108 12.4961 10.0898 12.4961C11.1286 12.4961 12.1471 12.7837 13.0324 13.3271C13.9177 13.8705 14.6352 14.6485 15.1055 15.5747",
  stroke: "#CAC4CF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M17.4851 8.75003C17.7488 10.3167 17.5078 11.9266 16.7968 13.3474C16.0858 14.7681 14.9417 15.9261 13.5296 16.6542C12.1176 17.3823 10.5107 17.6428 8.94092 17.3981C7.37117 17.1533 5.91983 16.416 4.79644 15.2926C3.67305 14.1693 2.93576 12.7179 2.69102 11.1482C2.44628 9.57842 2.70676 7.97151 3.43485 6.55946C4.16294 5.14741 5.32096 4.00329 6.74169 3.2923C8.16243 2.58132 9.77237 2.34026 11.339 2.60394",
  stroke: "#CAC4CF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M14.4648 4.375L15.7148 5.625L18.2148 3.125",
  stroke: "#CAC4CF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgUserCircleCheckDisabled);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/user_circle_check_disabled.89dd67bed90d2a89974d0eca777e7ded.svg";